import api from './api'
const categoriesDataProvider = {
  getCategories() {
    return api.get('Product/api/Product/GetAllCategories')
  },
  getCustomCategories() {
    return api.get('Product/api/Category/GetCustomCategory')
  },
  getParentCategories(params = {}) {
    return api.query('Product/api/Category/GetCategoryChildren', params)
  },
  getOneCategory(params) {
    return api.query('Product/api/Category/GetOne', { params })
  },
  createProductCategory(params = {}) {
    return api.post('Product/api/Category/CreateProductCategory', params)
  },
  editCategory(params = {}) {
    return api.put('Product/api/Category/EditCategory', params)
  },
  getCategoryList(params = {}) {
    return api.query('/Product/api/Category/getCategoryList', { params })
  },
  deleteCategory(params = {}) {
    return api.delete('/Product/api/Category/DeleteCategory', { params })
  },
  getCategoryFormBuilder(params = {}) {
    return api.query('Product/api/Category/GetCategoryForm', { params })
  },
  createCategoryFormBuilder(params) {
    return api.post('Product/api/Category/AddCategoryForm', params)
  },
  editCategoryFormBuilder(params) {
    return api.put('Product/api/Category/EditCategoryForm', params)
  },
}
export default categoriesDataProvider
